import { render, staticRenderFns } from "./MultimediaCenter.vue?vue&type=template&id=6b617478&scoped=true&"
import script from "./MultimediaCenter.vue?vue&type=script&lang=js&"
export * from "./MultimediaCenter.vue?vue&type=script&lang=js&"
import style0 from "./MultimediaCenter.vue?vue&type=style&index=0&id=6b617478&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b617478",
  null
  
)

export default component.exports